import React, { useState } from 'react';
import { timeGapBetweenInMinutes } from './OrdersUtil';
import OrderListItem from './components/OrderListItem';
import Button from '../../components/buttons/Button';
import { OrderListOrderClazz, Region } from '../../types/orderTypes';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import SimpleCheckBox from '../../components/inputs/Checkbox/SimpleCheckbox';

export function RenderOrderGroup({
  title,
  orders,
  totalNumber,
  onOrderSelected,
  selectedOrders,
  region,
  onSelectOrderClick,
}: {
  title: string;
  orders: OrderListOrderClazz[];
  totalNumber: number;
  onOrderSelected?: (orderId: string) => void;
  selectedOrders: { [orderId: string]: boolean };
  region: Region;
  onSelectOrderClick: (orderIds: { [orderId: string]: boolean }) => void;
}): JSX.Element {
  const [renderLength, setRenderLength] = useState(10);
  const [showGroupedOrders, toggleShowOption] = useState(true);
  const [isCheckedSelectDelivery, selectDeliveryToggle] = useState(false);
  const [isCheckedSelectLarge, selectLargeToggle] = useState(false);
  const orderDeliveries = orders.filter(order => order.product === 'delivery');
  const orderLarge = orders.filter(order => order.product === 'large');
  const orderDeliveryItems = createItems(orderDeliveries);
  const orderLargeItems = createItems(orderLarge);

  function createItems(orders: OrderListOrderClazz[]): JSX.Element[] {
    return orders.slice(0, renderLength).map((order, index) => {
      const minutesBetween =
        index === 0
          ? -1
          : timeGapBetweenInMinutes(
              orders[index - 1].deliverUntil,
              order.deliverFrom
            );
      const height = minutesBetween === 0 ? 5 : 19;
      return (
        <div key={order.id}>
          {minutesBetween >= 0 && (
            <div
              style={{
                height,
                fontSize: 12,
                textAlign: 'center',
                color: '#b5b5b5',
              }}
            >
              {minutesBetween === 0 ? '' : `${minutesBetween} minutes`}
            </div>
          )}
          <OrderListItem
            order={order}
            fetchingBundle={false}
            bundleId={order.bundleId}
            selected={selectedOrders[order.id]}
            onSelected={onOrderSelected && (() => onOrderSelected(order.id))}
            region={region}
          />
        </div>
      );
    });
  }

  const selectDeliveryChange = () => {
    const selectDeliveryObject = {};
    orderDeliveries.forEach(
      order => (selectDeliveryObject[order.id] = !isCheckedSelectDelivery)
    );
    onSelectOrderClick(selectDeliveryObject);
    selectDeliveryToggle(!isCheckedSelectDelivery);
  };

  const selectLargeChange = () => {
    const selectLargeObject = {};
    orderLarge.forEach(
      order => (selectLargeObject[order.id] = !isCheckedSelectLarge)
    );
    onSelectOrderClick(selectLargeObject);
    selectLargeToggle(!isCheckedSelectLarge);
  };
  const toggleView = () => toggleShowOption(!showGroupedOrders);
  return (
    <div className="order-list">
      <div onClick={toggleView} className="grouped-orders">
        {title} - {orders.length}/{totalNumber}
        {showGroupedOrders ? (
          <FaEye className="grouped-orders-eye" onClick={toggleView} />
        ) : (
          <FaEyeSlash className="grouped-orders-eye" onClick={toggleView} />
        )}
      </div>
      {showGroupedOrders ? (
        <>
          {orderDeliveries.length > 0 ? (
            <>
              <span className={'order-list-header'}>Delivery</span>
              <SimpleCheckBox
                selected={isCheckedSelectDelivery}
                label="Select all"
                onChange={selectDeliveryChange}
                labelId={`selectAll_${title} - ${orders.length} / ${totalNumber}`}
              />
              <div>{orderDeliveryItems}</div>
              {orderDeliveries.length > renderLength && (
                <Button
                  title={`Load more ${title}...`}
                  onClick={() => setRenderLength(renderLength + 10)}
                  style={{
                    width: '100%',
                    marginTop: '1em',
                    marginBottom: '1em',
                  }}
                />
              )}
            </>
          ) : (
            <></>
          )}
          {orderLarge.length > 0 ? (
            <>
              <span className={'order-list-header'}>Large</span>
              <SimpleCheckBox
                selected={isCheckedSelectLarge}
                label="Select all"
                onChange={selectLargeChange}
                labelId={`selectAll_${title} - ${orders.length} / ${totalNumber}`}
              />
              <div>{orderLargeItems}</div>
              {orderLarge.length > renderLength && (
                <Button
                  title={`Load more large ${title}...`}
                  onClick={() => setRenderLength(renderLength + 10)}
                  style={{
                    width: '100%',
                    marginTop: '1em',
                    marginBottom: '1em',
                  }}
                />
              )}
            </>
          ) : (
            <></>
          )}
        </>
      ) : null}
    </div>
  );
}
